import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Form,Tabs,Modal,Row,Col,Steps,message } from 'antd';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import approvalCenter from "../../services/Employee/approval-center-service";
import { Button, Icon, Divider} from 'antd';

class ApprovalCenter extends ReactAbstract {

	componentWillMount() {
		if ("loaded" !== this.state.dataStatus || this.initReload) {
			this.publicSelect();
		}
	}
	deleteRowSelection = true
	dataMode = 1
	initReload = false
	moduleName = "approval"
	childModuleName = "employeeApprovalCenter"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		filters: {
			tabIndex: "selectApprovalAction"
		},
		data: [],
		dataStatus: "unload",
		steps: [],
		approvalModalStatus: false,
		tabIndex: "selectApprovalAction",
    batchApproval: false,
    batchRows: []

	}

	actions = {
		selectApprovalAction: approvalCenter.fetchApprovalPending,
		selectCCAction: approvalCenter.fetchCcToMe,
		selectApprovedAction: approvalCenter.fetchApproved,
	}

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      let batchRow = selectedRows.map( row => {
        return {document_id: row.id, approval_type: row.approval_type}
      })
      this.setState({batchRows: batchRow})
    }
  };

	tableColumn = [{
			title: <div><div>序号</div><div>NO.</div></div>,
			key: "row_index",
			dataIndex: "row_index",
			className: 'table-global-head-tiny'
		}, {
			title: <div><div>申请类型</div><div>Approval Type</div></div>,
			key: "apply_type",
			dataIndex: "apply_type",
			className: 'table-global-head-small'
		}, {
			title: <div><div>姓名</div><div>Name</div></div>,
			key: "real_name",
			dataIndex: "real_name",
			className: 'table-global-head-small'
		}, {
			title: <div><div>提交时间</div><div>Submit Time</div></div>,
			key: "created_time_str",
			dataIndex: "created_time_str",
			className: 'table-global-head'
		}, {
			title: <div><div>申请内容</div><div>Apply Content</div></div>,
			key: "apply_content",
			dataIndex: "apply_content",
			className: 'table-global-head'
		},{
			title: <div><div>时长</div><div>Approval Hours</div></div>,
			key: "hours",
			dataIndex: "hours",
			className: 'table-global-head-small'
		},{
			title: <div><div>申请原因</div><div>Apply Reason</div></div>,
			key: "remark",
			dataIndex: "remark",
			className: 'table-global-head'
		}, {
			title: <div><div>审批状态</div><div>Status</div></div>,
			key: "approval_status_str",
			dataIndex: "approval_status_str",
			className: 'table-global-head-small'
		}, {
			title: <div><div>操作</div><div>Action</div></div>,
			key: "action",
			dataIndex: "action",
			className: 'table-global-head',
			render: (text, record, index) => (
				<DynamicButton column={this.buttonColumn(text, record, index)}
					module={this.childModuleName}
					access={this.props.access} />
			)
		}
	]

	buttonColumn = (text, record, index) => {

		let button = [{
			size: "small",
			type: "default",
			icon: "edit",
			title: "查看 View",
			access: "detail_value",
			click: () => this.setState({
				currentModalStatus: true,
				currentDataStatus: "unload",
				currentIndex: index
			}
			, () => {
					this.setState({
						currentData: this.dataSource().data.Data[index],
						currentDataStatus: "loaded"
					})
					approvalCenter.fetchApprovalFlowLog({document_id:record.id}, res => {
						this.setState({
							stepsCurrent:res.data.currentStep,
							steps:res.data.steps
						})
					})

			}
			)
		}];
		if (this.state.filters.tabIndex === "selectApprovalAction") {
			button.push({
				size: "small",
				type: "default",
				icon: "edit",
				title: "通过 Agree",
				access: "accept_value",
				click: () => this.setState({
          batchApproval: false,
					approvalModalStatus: true,
					isApproval: true,
					approval_status:1,
					approval_type:record.approval_type,
					document_id:record.id
				})
			})
			button.push({
				size: "small",
				type: "default",
				icon: "edit",
				title: "驳回 Reject",
				access: "reject_value",
				click: () => this.setState({
          batchApproval: false,
					approvalModalStatus: true,
					isApproval: false,
					approval_status:2,
					approval_type:record.approval_type,
					document_id:record.id
				})
			})
		}
		return button;
	}

	formColumn = () => [{
			label: <div><div>姓名</div><div>Name</div></div>,
			key: "real_name",
			type: "textex",
			span: 24
		}, {
			label: <div><div>部门</div><div>Department</div></div>,
			key: "department_name",
			type: "textex",
			span: 12
		}, {
			label: <div><div>职位</div><div>Position</div></div>,
			key: "position_name",
			type: "textex",
			span: 12
		}, {
			label: "",
			type: "title"
		}, {
			label: <div><div>申请类型</div><div>Approval Type</div></div>,
			key: "approval_type",
			type: "textex",
			span: 12
		}, {
			label: <div><div>申请选择</div><div>Apply Type</div></div>,
			key: "apply_type",
			type: "textex",
			span: 12
		}, {
			label: <div><div>开始日期</div><div>Start Date</div></div>,
			key: "start_date",
			type: "textex",
			span: 12
		}, {
			label: <div><div>开始时间</div><div>Start Time</div></div>,
			key: "start_time",
			type: "textex",
			span: 12
		}, {
			label: <div><div>结束日期</div><div>End Date</div></div>,
			key: "end_date",
			type: "textex",
			span: 12
		}, {
			label: <div><div>结束时间</div><div>End Time</div></div>,
			key: "end_time",
			type: "textex",
			span: 12
		}, {
			label: <div><div>时长</div><div>Hours</div></div>,
			key: "hours_str",
			type: "textex",
			span: 12
		}, {
			label: <div><div>提交时间</div><div>Submit Time</div></div>,
			key: "created_time_str",
			type: "textex",
			span: 12
		}, {
			label: <div><div>原因</div><div>Reason</div></div>,
			key: "remark",
			type: "textex",
			span: 24
		}
	]

	approvalColumn = [{
			label: "意见",
			key: "approval_content",
			type: "textarea",
			span: 24,
			valueWidth: "760px",
			rules: {rows: 5}
		}
	]

	// changeTabIndex = value => this.publicChange({tabIndex: value})
	changeTabIndex = value => {
		this.setState({
		dataStatus: "unload",
		filters: {page: 1},
		tabIndex: value
	}, this.publicSelect)
		this.publicChange({tabIndex: value})
	}

	publicSelect = () => {
		let gets = {}
		Object.keys(this.state.filters).forEach(key => {
			if (this.state.filters[key]) {
				gets[key] = this.state.filters[key];
			}
		});
		let apoLoadStatus = false;
		this.actions[this.state.tabIndex](gets, res => {
			if(res.data.Success || res.data.Success === undefined){
				apoLoadStatus = true;
				this.setState({
					dataStatus: "loaded",
					data: this.dataMode === 1 ? res.data.Object : res.data
				})
			}
			else{
					message.error(res.data.Message)
				}
			
		}, err => this.setState({dataStatus: "error"}))
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apoLoadStatus) {
				this.setState({dataStatus: "loading"})
			}
		}, 100)
	}

	toggleApprovalModal = () => this.setState({approvalModalStatus: !this.state.approvalModalStatus})

	publicApproval = () => this.props.form.validateFields((err, values) => {
		if (!err) {
		  if(!this.state.batchApproval) {
        const currentData = {
          document_id: this.state.document_id,
          approval_status: this.state.approval_status,
          approval_type: this.state.approval_type,
          approval_content:values.approval_content
        }

        approvalCenter.fetchApproval(currentData, res => {
          if (res.data.Success) {
            message.success("审批操作成功 Approval Success", 4);
            this.props.form.resetFields();
            this.setState({approvalModalStatus: false})
            this.actions.changeAction({}, "reload")
          }else{
            message.error(`审批操作失败 Approval Faild：${res.data.Errors}`);
          }
        }, err => {});
      }
      else {
        const currentData = {
          batch_approvals: this.state.batchRows,
          approval_status: this.state.approval_status,
          approval_content:values.approval_content
        }

        approvalCenter.fetchALLApproval(currentData, res => {
          if (res.data.Success) {
            message.success("审批操作成功 Approval Success", 4);
            this.props.form.resetFields();
            this.setState({approvalModalStatus: false})
            this.actions.changeAction({}, "reload")
          }else{
            message.error(`审批操作失败 Approval Faild：${res.data.Errors}`);
          }
        }, err => {});
      }
		}
	})

  batchApproval = () => this.setState({
    approvalModalStatus: true,
    approval_status:1,
    batchApproval: true
  })

  batchReject = () => this.setState({
    approvalModalStatus: true,
    approval_status:2,
    batchApproval: true
  })

	render() {
		return (

			<div className="app-module-item">
        {
          this.state.filters.tabIndex === "selectApprovalAction" &&
          <div className="colAction">
            <span><Button type="primary" onClick={this.batchApproval}>
            <Icon type="check-circle" />
            <span>通过 Agree</span>
            </Button>
            <Divider type="vertical" /></span>
            <span><Button type="primary"  onClick={this.batchReject}>
            <Icon type="close-circle" />
            <span>驳回 Reject</span>
            </Button>
            </span>
          </div>
        }

				<Tabs activeKey={this.state.filters.tabIndex}
					animated={false}
					onChange={this.changeTabIndex}>
					{this.props.access.employeeApprovalCenter.to_apply_value && <Tabs.TabPane tab="待审批 Pending Approval" key="selectApprovalAction"/>}
					{this.props.access.employeeApprovalCenter.to_me_value && <Tabs.TabPane tab="抄送给我的 CC To Me" key="selectCCAction"/>}
					{this.props.access.employeeApprovalCenter.approved_value && <Tabs.TabPane tab="已审批记录 Approved Record" key="selectApprovedAction" />}
				</Tabs>
				<Modal width="1000px"
					visible={this.state.approvalModalStatus}
					title="审批"
					destroyOnClose={true}
					onCancel={this.toggleApprovalModal}
					onOk={this.publicApproval} >
					<DynamicForm column={this.approvalColumn}
						form={this.props.form}
						loadStatus="loaded"
						dataSource={{}} />
				</Modal>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="审批中心"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.toggleCurrentModal} >
					<Row>
						<Col span={16}>
							<div style={{borderRight: "1px solid gray", paddingRight: "0px"}}>
								<DynamicForm column={this.formColumn}
									form={this.props.form}
									loadStatus={this.state.currentDataStatus}
									dataSource={this.state.currentData} />
							</div>
						</Col>
						<Col span={8}>
							<div style={{paddingLeft: "20px"}}>
								<Steps direction="vertical" size="small" current={this.state.stepsCurrent}>
									{this.state.steps.map((step, index) => (
										<Steps.Step title={step.approval_user_name}
										 key={index}
										 description={step.description} />
									))}
								</Steps>
							</div>
						</Col>
					</Row>
				</Modal>
				<div>
          {
            this.state.filters.tabIndex === "selectApprovalAction" && <DynamicTable column={this.tableColumn} rowSelection={this.rowSelection}
            dataStatus={this.dataSource().dataStatus}
            dataSource={this.dataSource().data.Data}
            pagination={{
              total: this.dataSource().data.Total,
                pageSize: this.dataSource().data.PageSize,
                current: this.dataSource().filters.page}}
            setPageFilter={this.publicChange} />
          }

          {
            (this.state.filters.tabIndex === "selectApprovedAction" || this.state.filters.tabIndex === "selectCCAction") && <DynamicTable column={this.tableColumn}
            dataStatus={this.dataSource().dataStatus}
            dataSource={this.dataSource().data.Data}
            pagination={{
            total: this.dataSource().data.Total,
              pageSize: this.dataSource().data.PageSize,
              current: this.dataSource().filters.page}}
            setPageFilter={this.publicChange} />
          }

				</div>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
	}
}

const mapDispatchToProps = {
}

ApprovalCenter = Form.create()(ApprovalCenter);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ApprovalCenter));


// WEBPACK FOOTER //
// ./src/routes/Employee/ApprovalCenterEn.js